import { Component } from 'react'

import { default as swal } from 'sweetalert2'
import { connect } from 'react-redux'

class AlertHandler extends Component {
  render () {
    if (this.props.alert && this.props.alert.title) {
      swal({
        ...this.props.alert
      }).then(() => {
        this.props.dispatch({type: 'ALERT_CLEAR', payload: ''})
      })
    }
    return null
  }
}
// eslint-disable-next-line
AlertHandler = connect(state => state.siteReducer)(AlertHandler)
export default AlertHandler



// WEBPACK FOOTER //
// ./src/components/core/AlertHandler.js